module.exports = __webpack_public_path__ + "static/media/icon-social_media-linkedin.77dac249.svg";